import {
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_USERS_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  GET_ROLES_REQUEST,
  GET_ROLES_SUCCESS,
  GET_ROLES_FAILURE,
  CREATE_ROLE_REQUEST,
  CREATE_ROLE_SUCCESS,
  CREATE_ROLE_FAILURE,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_FAILURE,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAILURE,
  GET_ROLE_PERMISSIONS_REQUEST,
  GET_ROLE_PERMISSIONS_SUCCESS,
  GET_ROLE_PERMISSIONS_FAILURE,
  UPDATE_ROLE_PERMISSIONS_REQUEST,
  UPDATE_ROLE_PERMISSIONS_SUCCESS,
  UPDATE_ROLE_PERMISSIONS_FAILURE,
  GET_AVAILABLE_MODULES_REQUEST,
  GET_AVAILABLE_MODULES_SUCCESS,
  GET_AVAILABLE_MODULES_FAILURE,
} from '../types';
import api from '../../services/api';

// User Actions
export const getUsers = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_USERS_REQUEST });
    const response = await api.get('/user-management/users', { params });
    dispatch({
      type: GET_USERS_SUCCESS,
      payload: response.data.data,
    });
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get users';
    dispatch({ type: GET_USERS_FAILURE, payload: message });
    return { success: false, message };
  }
};

export const createUser = (userData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_USER_REQUEST });
    const response = await api.post('/user-management/users', userData);
    dispatch({ type: CREATE_USER_SUCCESS, payload: response.data.data });
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create user';
    dispatch({ type: CREATE_USER_FAILURE, payload: message });
    return { success: false, message };
  }
};

export const updateUser = (id, userData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_USER_REQUEST });
    const response = await api.put(`/user-management/users/${id}`, userData);
    dispatch({ type: UPDATE_USER_SUCCESS, payload: response.data.data });
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update user';
    dispatch({ type: UPDATE_USER_FAILURE, payload: message });
    return { success: false, message };
  }
};

export const deleteUser = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_USER_REQUEST });
    await api.delete(`/user-management/users/${id}`);
    dispatch({ type: DELETE_USER_SUCCESS, payload: id });
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to delete user';
    dispatch({ type: DELETE_USER_FAILURE, payload: message });
    return { success: false, message };
  }
};

// Role Actions
export const getRoles = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_ROLES_REQUEST });
    const response = await api.get('/user-management/roles', { params });
    dispatch({ type: GET_ROLES_SUCCESS, payload: response.data.data });
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get roles';
    dispatch({ type: GET_ROLES_FAILURE, payload: message });
    return { success: false, message };
  }
};

export const createRole = (roleData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ROLE_REQUEST });
    const response = await api.post('/user-management/roles', roleData);
    dispatch({ type: CREATE_ROLE_SUCCESS, payload: response.data.data });
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create role';
    dispatch({ type: CREATE_ROLE_FAILURE, payload: message });
    return { success: false, message };
  }
};

export const updateRole = (id, roleData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_ROLE_REQUEST });
    const response = await api.put(`/user-management/roles/${id}`, roleData);
    dispatch({ type: UPDATE_ROLE_SUCCESS, payload: response.data.data });
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update role';
    dispatch({ type: UPDATE_ROLE_FAILURE, payload: message });
    return { success: false, message };
  }
};

export const deleteRole = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_ROLE_REQUEST });
    await api.delete(`/user-management/roles/${id}`);
    dispatch({ type: DELETE_ROLE_SUCCESS, payload: id });
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to delete role';
    dispatch({ type: DELETE_ROLE_FAILURE, payload: message });
    return { success: false, message };
  }
};

// Permission Actions
export const getRolePermissions = (roleId) => async (dispatch) => {
  try {
    dispatch({ type: GET_ROLE_PERMISSIONS_REQUEST });
    const response = await api.get(`/user-management/roles/${roleId}/permissions`);
    dispatch({ type: GET_ROLE_PERMISSIONS_SUCCESS, payload: response.data.data });
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get permissions';
    dispatch({ type: GET_ROLE_PERMISSIONS_FAILURE, payload: message });
    return { success: false, message };
  }
};

export const updateRolePermissions = (roleId, permissions) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_ROLE_PERMISSIONS_REQUEST });
    const response = await api.put(`/user-management/roles/${roleId}/permissions`, { permissions });
    dispatch({ type: UPDATE_ROLE_PERMISSIONS_SUCCESS, payload: response.data.data });
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update permissions';
    dispatch({ type: UPDATE_ROLE_PERMISSIONS_FAILURE, payload: message });
    return { success: false, message };
  }
};

export const getAvailableModules = () => async (dispatch) => {
  try {
    dispatch({ type: GET_AVAILABLE_MODULES_REQUEST });
    const response = await api.get('/user-management/permissions/modules');
    dispatch({ type: GET_AVAILABLE_MODULES_SUCCESS, payload: response.data.data });
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get modules';
    dispatch({ type: GET_AVAILABLE_MODULES_FAILURE, payload: message });
    return { success: false, message };
  }
};

